"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const date_fns_1 = require("date-fns");
const command_1 = require("../../type/command");
const entity_1 = require("../../type/entity");
function getDueDateFromType(command, dueDateDetail, timeStamp) {
    const dueDateType = dueDateDetail.type;
    const { type: commandType } = command;
    switch (dueDateType) {
        case entity_1.DueDateType.CONTENT_DEPENDENT: {
            if (commandType === command_1.CommandType.ASSIGN_CONTENT) {
                return '-1';
            }
            const dynamicDueDateDetail = dueDateDetail;
            return date_fns_1.addDays(timeStamp, dynamicDueDateDetail.dueInDays).toISOString();
        }
        case entity_1.DueDateType.DYNAMIC: {
            if (timeStamp === '-1') {
                return timeStamp;
            }
            const dynamicDueDateDetail = dueDateDetail;
            return date_fns_1.addDays(timeStamp, dynamicDueDateDetail.dueInDays).toISOString();
        }
        case entity_1.DueDateType.RELATIVE:
        case entity_1.DueDateType.FIXED: {
            const fixedDueDateDetail = dueDateDetail;
            return new Date(fixedDueDateDetail.dueDate).toISOString();
        }
        case entity_1.DueDateType.NO_DUE_DATE: {
            return '-1';
        }
        default:
            return timeStamp;
    }
}
exports.getDueDateFromType = getDueDateFromType;
function getDueDateOfEnrolment(enrolment) {
    const { enrolmentInfo } = enrolment;
    const enrolmentInfoLastIndex = enrolmentInfo.length - 1;
    const enrolmentDueDate = enrolmentInfo[enrolmentInfoLastIndex].dueDate;
    return enrolmentDueDate;
}
exports.getDueDateOfEnrolment = getDueDateOfEnrolment;
//# sourceMappingURL=getDueDate.js.map